import "../../dashboard-cme/dashboard-cme.scss";

const workloadClass = (workload) => {
    switch (workload) {
        case "Light":
            return "green";
        case "Medium":
            return "yellow";
        case "Heavy":
            return "orange";
        case "Very Heavy":
            return "red";
        default: return "";

    }
}

const availableCapacityClass = (name) => {
    switch (name) {
        case "Available":
        case "Available (smaller projects)":
            return "green";
        case "Limited Availability":
            return "orange";
        case "Not Available":
            return "red";
    }
}

const prevWeekendClass = (name) => {
    switch (name) {
        case "None":
            return "grey";
        case "Light(from home)":
        case "Light(from office)":
            return "green";
        case "Heavy(from home)":
        case "Heavy(from office)":
            return "red";
        default: return "";
    }
}

export const CMEWorkload = ({ workload }) => {
    return (
        <div className={`cmeBadge ${workloadClass(workload)}`}>
            <div className="cmeBadgeText">{workload}</div>
        </div>
    );
};

export const CMEAvailableCapacity = ({ capacity }) => {
    return (
        <div className={`cmeBadge ${availableCapacityClass(capacity)}`}>
            <div className="cmeBadgeText">{capacity}</div>
        </div>
    );
};

export const CMEPrevWeekend = ({ weekend }) => {
    // #1D7D2C
    let color = prevWeekendClass(weekend)
    return (
        <div className={`cmeBadge ${color}`}>
            <div className="cmeBadgeText d-flex align-items-center">
                {(color == "green" || color == "red") &&
                    <div>
                        {
                            weekend.includes("office") ?
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M4 2C2.89543 2 2 2.89543 2 4V17C2 17.5523 2.44772 18 3 18H10.5C10.7761 18 11 17.7761 11 17.5V15.5C11 15.2239 11.2239 15 11.5 15H14.5C14.7761 15 15 15.2239 15 15.5V17.5C15 17.7761 15.2239 18 15.5 18H17C17.5523 18 18 17.5523 18 17V7C18 5.89543 17.1046 5 16 5H12V4C12 2.89543 11.1046 2 10 2H4ZM11 5H10C8.89543 5 8 5.89543 8 7V17H3V4C3 3.44772 3.44772 3 4 3H10C10.5523 3 11 3.44772 11 4V5ZM5.25 9.5C5.66421 9.5 6 9.16421 6 8.75C6 8.33579 5.66421 8 5.25 8C4.83579 8 4.5 8.33579 4.5 8.75C4.5 9.16421 4.83579 9.5 5.25 9.5ZM6 5.75C6 6.16421 5.66421 6.5 5.25 6.5C4.83579 6.5 4.5 6.16421 4.5 5.75C4.5 5.33579 4.83579 5 5.25 5C5.66421 5 6 5.33579 6 5.75ZM5.25 15.5C5.66421 15.5 6 15.1642 6 14.75C6 14.3358 5.66421 14 5.25 14C4.83579 14 4.5 14.3358 4.5 14.75C4.5 15.1642 4.83579 15.5 5.25 15.5ZM6 11.75C6 12.1642 5.66421 12.5 5.25 12.5C4.83579 12.5 4.5 12.1642 4.5 11.75C4.5 11.3358 4.83579 11 5.25 11C5.66421 11 6 11.3358 6 11.75ZM11.25 9.5C10.8358 9.5 10.5 9.16421 10.5 8.75C10.5 8.33579 10.8358 8 11.25 8C11.6642 8 12 8.33579 12 8.75C12 9.16421 11.6642 9.5 11.25 9.5ZM12 11.75C12 12.1642 11.6642 12.5 11.25 12.5C10.8358 12.5 10.5 12.1642 10.5 11.75C10.5 11.3358 10.8358 11 11.25 11C11.6642 11 12 11.3358 12 11.75ZM14.75 9.5C14.3358 9.5 14 9.16421 14 8.75C14 8.33579 14.3358 8 14.75 8C15.1642 8 15.5 8.33579 15.5 8.75C15.5 9.16421 15.1642 9.5 14.75 9.5ZM15.5 11.75C15.5 12.1642 15.1642 12.5 14.75 12.5C14.3358 12.5 14 12.1642 14 11.75C14 11.3358 14.3358 11 14.75 11C15.1642 11 15.5 11.3358 15.5 11.75Z" fill={color == "green" ? "#1D7D2C" : "#C11919"} />
                                </svg>
                                :
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M11.0025 2.38811C10.4323 1.87584 9.56767 1.87584 8.9975 2.38811L3.4975 7.32965C3.18086 7.61414 3 8.01977 3 8.44544V15.4996C3 16.328 3.67157 16.9996 4.5 16.9996H6.5C7.32843 16.9996 8 16.328 8 15.4996V11.4996C8 11.2234 8.22386 10.9996 8.5 10.9996H11.5C11.7761 10.9996 12 11.2234 12 11.4996V15.4996C12 16.328 12.6716 16.9996 13.5 16.9996H15.5C16.3284 16.9996 17 16.328 17 15.4996V8.44544C17 8.01977 16.8191 7.61414 16.5025 7.32965L11.0025 2.38811Z" fill={color == "green" ? "#1D7D2C" : "#C11919"} />
                                </svg>
                        }

                    </div>}
                {weekend}
            </div>
        </div>
    );
};


